export const setWebsiteUrl = (url) => {
  return "https://" + url;
}

export const transformIdentifier = (identifier) => {
  let editedString = identifier.toLowerCase();
  editedString = editedString.replaceAll(' ', '_');
  editedString = editedString.replaceAll('à', 'a');
  editedString = editedString.replaceAll('á','a');
  editedString = editedString.replaceAll('ã','a');
  editedString = editedString.replaceAll('â','a');

  editedString = editedString.replaceAll('é','e');
  editedString = editedString.replaceAll('ê','e');

  editedString = editedString.replaceAll('í','i');
  editedString = editedString.replaceAll('ì','i');

  editedString = editedString.replaceAll('ó','o');
  editedString = editedString.replaceAll('ò','o');
  editedString = editedString.replaceAll('õ','o');
  editedString = editedString.replaceAll('ô','o');

  editedString = editedString.replaceAll('ú','u');
  editedString = editedString.replaceAll('ù','u');


  editedString = editedString.replaceAll(/\W/g, '');

  return editedString;
}

export const getDateString = () => {
  const dateObj = new Date();
  const month = dateObj.getUTCMonth() + 1; //months from 1-12
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();

  return "_" + year + "_" + month + "_" + day;

}